import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { LOGS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const AutomationErrorLogList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'id',
				filterType: FilterType.number,
				width: 50,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'otoOrderID',
				accessor: 'otoOrderId',
				filterType: FilterType.number,
				width: 50,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderId',
				filterType: FilterType.number,
				width: 50,
				showCopyButton: true
			},
			{
				Header: 'name',
				accessor: 'automationName',
				filterType: FilterType.string,
				width: 80,
				showOnMobile: true
			},
			{
				Header: 'actionName',
				accessor: 'actionName',
				filterType: FilterType.string,
				width: 80,
				showOnMobile: true
			},
			{
				Header: 'actionType',
				accessor: 'actionType',
				filterType: FilterType.multiSelection,
				width: 50
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.multiSelection,
				width: 50
			},
			{
				Header: 'functionName',
				accessor: 'functionName',
				filterType: FilterType.multiSelection,
				width: 50
			},
			{
				Header: 'siteName',
				accessor: 'siteName',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'request',
				accessor: 'requestJson',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'response',
				accessor: 'responseJson',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'updateTime',
				accessor: 'updateTime',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				show: false,
				width: 100
			},
			{
				Header: 'nextAttemptTime',
				accessor: 'nextAttemptTime',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME,
				show: false,
				width: 100
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.AUTOMATION_ERROR_LOGS}
				columns={columns}
				fetchUrl={LOGS.GET_AUTOMATION_ERROR_LOGS_LIST}
				defaultSort={defaultSort}
				exportName="automationErrorLogs"
				infiniteScroll
			/>
		</TabTableContainer>
	);
};

export default AutomationErrorLogList;
